import HttpClient from "../http-client";
import { Observable } from "rxjs";
import { API_URL } from "../../enums/api.enums";

export interface LayoutSection {
  id: number;
  name: string;
  displayName: string;
  description?: string;
  isActive: boolean;
  config?: any;
}

export interface LayoutOrder {
  id: number;
  sectionId: number;
  order: number;
  isVisible: boolean;
  config?: any;
  section: LayoutSection;
}

export interface CreateSectionRequest {
  name: string;
  displayName: string;
  description?: string;
  config?: any;
  isActive: boolean;
}

export interface UpdateSectionRequest {
  name?: string;
  displayName?: string;
  description?: string;
  config?: any;
  isActive?: boolean;
}

export interface UpdateLayoutOrderRequest {
  sections: Array<{
    sectionId: number;
    order: number;
    isVisible?: boolean;
    config?: any;
  }>;
}

class HomeLayoutApi {
  // Section Management
  static getSections(): Observable<any> {
    return HttpClient.get(`${API_URL.HOST}/${API_URL.HOME_LAYOUT_SECTIONS}`);
  }

  static createSection(data: CreateSectionRequest): Observable<any> {
    return HttpClient.post(`${API_URL.HOST}/${API_URL.HOME_LAYOUT_SECTIONS}`, data);
  }

  static updateSection(id: number, data: UpdateSectionRequest): Observable<any> {
    return HttpClient.patch(`${API_URL.HOST}/${API_URL.HOME_LAYOUT_SECTIONS}/${id}`, data);
  }

  static deleteSection(id: number): Observable<any> {
    return HttpClient.delete(`${API_URL.HOST}/${API_URL.HOME_LAYOUT_SECTIONS}/${id}`);
  }

  // Layout Order Management
  static getLayoutOrder(): Observable<any> {
    return HttpClient.get(`${API_URL.HOST}/${API_URL.HOME_LAYOUT_ORDER}`);
  }

  static updateLayoutOrder(data: UpdateLayoutOrderRequest): Observable<any> {
    return HttpClient.post(`${API_URL.HOST}/${API_URL.HOME_LAYOUT_ORDER}`, data);
  }

  static initializeDefaultSections(): Observable<any> {
    return HttpClient.post(`${API_URL.HOST}/${API_URL.HOME_LAYOUT_INITIALIZE}`, {});
  }

  // Public endpoint for getting layout (for the actual home page)
  static getPublicLayout(): Observable<any> {
    return HttpClient.get(`${API_URL.HOST}/${API_URL.HOME_LAYOUT_PUBLIC}`);
  }
}

export default HomeLayoutApi;
